<template>
  <v-navigation-drawer :mini-variant.sync="mini" v-model="drawer" stateless>
    <v-toolbar flat class="transparent">
      <v-list class="pa-0">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon>build</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>{{header}}</v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon @click.stop="toggleMini()">
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-divider></v-divider>
    <NewRoute v-if="addRoute && !mini" />
    <EditRoute @onRouteUpdate="routeUpdated" v-if="editRoute && !mini" />
  </v-navigation-drawer>
</template>

<script>
import NewRoute from "./forms/NewRoute";
import EditRoute from "./forms/EditRoute";
//import AddLocationToRoute from './forms/AddLocationToRoute';

export default {
  name: "NavigationDrawer",
  components: { NewRoute, EditRoute },

  data() {
    return {
      mini: false,
      drawer: true,
      valid: false,
      items: [
        { title: "Home", icon: "dashboard" },
        { title: "About", icon: "question_answer" }
      ],

      right: null
    };
  },

  methods: {
    routeUpdated(route) {
      console.log("navigation drawer", route);
      this.$emit("onRouteUpdate", route);
    },

    toggleMini() {
      this.mini = !this.mini;

      //window.vm.$emit('invalidateSize');
    }
  },

  computed: {
    translater: {
      get() {
        return this.$store.getters["translate/translater"];
      }
    },

    header: {
      get() {
        let h = this.$store.getters["drawer/header"];

        return this.translater.__(h, "routes");
      }
    },

    addRoute: {
      get() {
        return this.$store.getters["drawer/formAddRoute"];
      }
    },

    addLocationToRoute: {
      get() {
        return this.$store.getters["drawer/formAddLocationToRoute"];
      }
    },

    editRoute: {
      get() {
        return this.$store.getters["drawer/formEditRoute"];
      }
    },

    showBack: {
      get() {
        return this.$store.getters["drawer/showBack"];
      }
    }
  }
};
</script>

<style>
.white-bg {
  background-color: #ccc;
}
</style>